import { invoiceStatusColor, invoiceStatusLabel } from '@/filters'

export default {
  name: 'EditBillingInvoicesItems',
  filters: { invoiceStatusColor, invoiceStatusLabel },
  props: {
    items: {
      required: true,
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      required: true,
      type: Boolean,
      default: true
    }
  }
}
